import { DataMartTable } from '@r1-compass-library/models';
import { computed, Injectable, inject } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { DataMartService } from '@r1-compass-library/services';
import { exhaustMap, Observable } from 'rxjs';
import { tapResponse } from '@ngrx/operators';

export interface DataMartModelState {
    model: DataMartTable[] | undefined;
}

const initialState: DataMartModelState = {
    model: undefined,
};

@Injectable()
export class DataMartModelsStore extends ComponentStore<DataMartModelState> {
    readonly #dataMartService = inject(DataMartService);

    model$ = this.select(state => state.model);
    model = this.selectSignal(state => state.model);
    genericCriteriaTables = computed(() => {
        return this.model()?.filter(table => {
            return table.fields.at(0)?.selectCriteria === 'Generic Criteria';
        });
    });
    modelTables = computed(() => {
        return this.model()?.filter(table => {
            return table.fields.at(0)?.selectCriteria === 'Model Criteria';
        });
    });

    constructor() {
        super(initialState);
    }

    setDataModel = this.updater((state, model: DataMartTable[]) => ({
        ...state,
        model: model,
    }));
    getDataModel = this.effect((trigger$: Observable<void>) => {
        return trigger$.pipe(
            exhaustMap(trigger => {
                return this.#dataMartService.getDataModel().pipe(
                    tapResponse({
                        next: dataModel => {
                            this.setDataModel(dataModel?.tables ?? []);
                        },
                        error: err => {
                            console.error(err);
                            //clear out what was there so we don't have stale data
                            this.setDataModel([]);
                        },
                    })
                );
            })
        );
    });
}
